import React, { useCallback, useEffect, useState } from 'react';
import { gql, useMutation } from '@apollo/client';

import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import IconButton from '@mui/material/IconButton';

// import FavoriteActions from '../flux/actions/FavoriteActions';
// import client from '../utility/apolloEnvironment';
// import FavoriteStore from '../flux/stores/FavoritesStore';

const ADD_FAVORITE = gql`
  mutation AddFavorite ($itemId: Guid!) {
    addFavoriteByItemId (itemId: $itemId) {
      favoriteId
      item {
        id
        itemId
      }
    }
  }  
`

const REMOVE_FAVORITE = gql`
  mutation RemoveFavorite ($favoriteId: Guid!) {
    removeFavoriteByFavoriteId (favoriteId: $favoriteId) {
      id
    }
  } 
`;


const Icon = (props) => {
  const { itemId, currentUser, GET_USER } = props;
  const {favorites} = currentUser;
  const checkFavorites = useCallback(fav => fav.item.itemId === itemId, [itemId]);
  const [favoriteId, setFavoriteId] = useState(null);
  const [active, setActive] = useState(false);
  
  const [addFavoriteByItemId, addFavoriteQuery] = useMutation(ADD_FAVORITE, {
    refetchQueries: [
      GET_USER,
      'getCurrentUser'
    ]
  });

  const [removeFavoriteByFavoriteId] = useMutation(REMOVE_FAVORITE, {
    refetchQueries: [
      GET_USER,
      'getCurrentUser'
    ]
  });

  useEffect(() => {
    if (!addFavoriteQuery.loading && addFavoriteQuery.data) {
      setFavoriteId(addFavoriteQuery.data.addFavoriteByItemId.filter(checkFavorites)[0].favoriteId);
    }
  }, [addFavoriteQuery, checkFavorites]);

  function addFavorite(item) {
    addFavoriteByItemId({variables: {itemId: item}})
  }

  function removeFavorite(id) {
    removeFavoriteByFavoriteId({variables: {favoriteId: id}})
  }

  // on load
  useEffect(() => {
    if(favorites && favorites.filter(checkFavorites)[0] !== undefined) {
      setActive(true);
      setFavoriteId(favorites.filter(checkFavorites)[0].favoriteId);
    }
  }, [favorites, checkFavorites]);

  const handleClick = () => {
    if(!active) {
      setActive(!active);
      //console.log('I should add')
      addFavorite(itemId);
    } else {
      setActive(!active);
      //console.log('I should remove')
      removeFavorite(favoriteId)
    }
  }

  if (currentUser === 'Guest') { return null; }
  
  const ariaLabel = active ? 'Remove from favorites' : 'Add to favorites';
  const title = active ? 'Remove from favorites' : 'Add to favorites';
  
  return (
    <IconButton 
      className={"favorite--icon"} 
      onClick={handleClick}
      aria-label={ariaLabel}
      title={title}
    >
      {active ? <FavoriteIcon /> : <FavoriteBorderIcon />}
    </IconButton>
  )
}

export default Icon;